export default __webpack_public_path__ + "static/Inter-Light-eec8664621fec98efb3798b3ad4177aa.ttf";